<template>
    <MainContainer background="lightGrey">
        <TestChild/>
    </MainContainer>
</template>

<script>
import MainContainer from '@/components/layout/MainContainer.vue';
import TestChild from '@/components/test/TestChild.vue';

export default {
    components: {
        MainContainer,
        TestChild
    }
};
</script>
